import { useContext, useState, useEffect } from 'react';

import { Page, Header, Button, icons } from 'daymap-library';
import Logo, { SchoolLogo } from '../../components/Logo/Logo';
import { Routes, Route, useNavigate, useLocation, matchPath } from 'react-router-dom';
import Settings from '../Settings/Settings';
import SignInOut from './SignInOut/SignInOut';
import { useAuth } from '../../helpers/authContext';
import { Loading } from 'daymap-library';
import { useApp } from '../../helpers/appContext';
import styles from './CheckIn.module.scss';

const menus = [
  { id: 0, text: 'Change Mode', iconCode: icons.ICON_CSS_CLASS.Switch},
  { id: 1, text: 'Settings', iconCode: icons.ICON_CSS_CLASS.Settings},
]

function Checkin() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setStudent, mode, setAppType, setMode } = useApp();
  const [InActionData, setInActionData] = useState(null);
  const [OutActionData, setOutActionData] = useState(null);
  const { lmsFetch, signOutMenu } = useAuth();
  const [pageTitle, setPageTitle] = useState('Check In');

  const menuClicked = item => {
    switch (item.text) {
      case 'Change Mode': {
        setAppType(null);
        setMode(null);
        navigate('/');
        break;
      }
      case 'Settings': {
        setSettingsOpen(true);
      }
      default: {}
    }
  }

  useEffect(() => {
    const navigation_info = window.performance.getEntriesByType("navigation")[0]
    if(navigation_info.type == "reload")
    {
      if(!location.pathname.endsWith('checkin') && (navigation_info.name.endsWith("/in") || navigation_info.name.endsWith("/out")))
      {
        navigate("/checkin");
      }
    }

    getInActions();
    getOutActions();
  },[]);

  useEffect(() => {
    let newTitle = null;
    if (!location.pathname.endsWith('checkin') && location.pathname.endsWith('in'))
      newTitle = `Sign In`;
    else if (location.pathname.endsWith('out'))
      newTitle = `Sign Out`;

      setPageTitle(newTitle);
  }, [location.pathname]);

  const getInActions = async () => {
    const [InActionData,cancelIn] = lmsFetch(`/lms/api/checkin/signinoutactions?mode=${mode}&action=In`);
    const InResponse = await InActionData();
    setInActionData(InResponse.data);
  }

  const getOutActions = async () => {
    const [OutActionData,cancelOut] = lmsFetch(`/lms/api/checkin/signinoutactions?mode=${mode}&action=Out`);
    const OutResponse = await OutActionData();
    setOutActionData(OutResponse.data);
  }

  const backButtonClicked = () => {
    const { pathname } = window.location;
    const page = pathname.substring(pathname.lastIndexOf('/'));
    switch (page) {
        case '/in':
        case '/out':
            setStudent(null);
            navigate('/checkin');
            break;
        case '/checkin':
            navigate('/');
            break;
        default:
            break;
    }
  }

  let onBackButtonClick = !matchPath('/checkin', location.pathname) ? () => backButtonClicked() : null;

  if(InActionData != null && OutActionData != null){
    return (
      <Page hasHeader center>
          {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
          <Header title={pageTitle || <Logo />} onMenuItemClick={menuClicked}  onBackButtonClick={onBackButtonClick} menus={signOutMenu && [signOutMenu]} />
          <Routes>
              <Route path="/" element={<CheckInHome inActions={InActionData} outActions={OutActionData}/>} />
              <Route path="/out" element={<SignInOut action = 'Out' actionData={OutActionData} />} />
              <Route path="/in" element={<SignInOut action = 'In' actionData={InActionData} />} />
          </Routes>
      </Page>
    )
  }else{
    return <Loading/>
  }

}

const CheckInHome = ({inActions, outActions}) => {
    const navigate = useNavigate();
    const { setStudent } = useApp();

    useEffect(() => {
      setStudent(null);
    }, [])

    return <div className={styles.CheckIn}>
      <SchoolLogo/>
      {inActions.length === 0 && outActions.length === 0 && <p>No Actions have been configured for the selected mode</p>}
      <div>
        {inActions.length > 0 && <Button text="Sign In" large onClick={() => navigate('in')}></Button>}
        {outActions.length > 0 && <Button text="Sign Out" large onClick={() => navigate('out')}></Button>}
      </div>
    </div>
}

export default Checkin;